import React from "react";
import styled from "styled-components";
import { useSelectStoreQuery } from "../../api/userAPI";
import reuseQueryStringV2 from "../../utils/reuseQueryStringV2";
import { useAppSelector } from "../../store/actions/action";

const initFilter: Filter = { sortSearchString: "최신순", newStoreSearchString: "", typeSearchArray: [], contentsSearchString: "" };

const ComfirmItem = () => {
  const storeListAPI = useSelectStoreQuery(reuseQueryStringV2(initFilter));
  const noticeData = useAppSelector((state) => state.noticeReduce);

  return (
    <>
      {storeListAPI.data.data.map(
        (store: Store) =>
          noticeData.beforeStores &&
          noticeData.beforeStores.includes(store.user_id) && (
            <ComfirmItemSet key={store.user_id}>
              <span className="tag">{store.store_type_name}</span>
              <span className="title">
                {store.name}
                <span className="userId">{store.user_id}</span>
              </span>
            </ComfirmItemSet>
          ),
      )}
    </>
  );
};

const ComfirmItemSet = styled.li`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")}
  .tag {
    display: inline-block;
    width: 60px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    background-color: #f4f4f4;
    font-size: 14px;
    color: #60677d;
    text-align: center;
    flex-shrink: 0;
  }
  .title {
    flex-grow: 1;
    padding-left: 16px;
    ${({ theme }) => theme.textOverflow.singleLine()}
    font-size: 16px;
    font-weight: 700;
    .userId {
      position: relative;
      top: -1px;
      display: inline-block;
      margin-left: 8px;
      padding-left: 8px;
      border-left: 2px solid ${({ theme }) => theme.color.lineSecondary};
      color: ${({ theme }) => theme.color.quaternary};
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export default ComfirmItem;
